import { useRef, useState } from "react"
import { useReactToPrint } from "react-to-print"
import { useTranslation } from "react-i18next"
import { CountsItem } from "./CountsItem"
import openIcon from "./selecticon.png"

export const CountsValue = () => {
 // language translator
 const { t } = useTranslation("translation")
 const [startIndex, setStartIndex] = useState(0)
 const componentRef = useRef(null)

 const nestedArrayStructure = [
  {
   heading: "Forum Gera: Stm.5 Forum Gera",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
    {
     heading: "Status",
     info: "",
     submenu: [
      {
       heading: "Status",
       info: "Schwer gestört",
       submenu: [],
      },
      {
       heading: "Kommunikation",
       info: "STm.5",
       submenu: [],
      },
      {
       heading: "Anlagenzustand",
       info: "unbekannt Aus - dunkel",
       submenu: [],
      },
      {
       heading: "Störungsstatus",
       info: "unbekannt abgeschaltet oder schwer gestört",
       submenu: [],
      },
      {
       heading: "Betriebsart",
       info: "unbekannt Lokale Zeitautomatik",
       submenu: [],
      },
      {
       heading: "letzte Statusänderung",
       info: "10.02.2023 11:17:34",
       submenu: [],
      },
      {
       heading: "Verkehrsabhängigkeit",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "ÖPNV",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Individualverkehr",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Status",
       info: "",
       submenu: [
        {
         heading: "Änderungszeitpunkt",
         info: "31.01.2023 10:37:27",
         submenu: [],
        },
        {
         heading: "Zeitquelle",
         info: "Zentrale",
         submenu: [],
        },
        {
         heading: "Not-Aus",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Tür auf",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Netzspannung ok",
         info: "ja",
         submenu: [],
        },
        {
         heading: "Gestörte Detektoren",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Gestörte Lampen",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Persistenzspeicher ok",
         info: "ja",
         submenu: [],
        },
       ],
      },
     ],
    },
   ],
  },
  {
   heading: "Forum Gera: Stm.5 Forum Gera",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
    {
     heading: "Status",
     info: "",
     submenu: [
      {
       heading: "Status",
       info: "Schwer gestört",
       submenu: [],
      },
      {
       heading: "Kommunikation",
       info: "STm.5",
       submenu: [],
      },
      {
       heading: "Anlagenzustand",
       info: "unbekannt Aus - dunkel",
       submenu: [],
      },
      {
       heading: "Störungsstatus",
       info: "unbekannt abgeschaltet oder schwer gestört",
       submenu: [],
      },
      {
       heading: "Betriebsart",
       info: "unbekannt Lokale Zeitautomatik",
       submenu: [],
      },
      {
       heading: "letzte Statusänderung",
       info: "10.02.2023 11:17:34",
       submenu: [],
      },
      {
       heading: "Verkehrsabhängigkeit",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "ÖPNV",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Individualverkehr",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Status",
       info: "",
       submenu: [
        {
         heading: "Änderungszeitpunkt",
         info: "31.01.2023 10:37:27",
         submenu: [],
        },
        {
         heading: "Zeitquelle",
         info: "Zentrale",
         submenu: [],
        },
        {
         heading: "Not-Aus",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Tür auf",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Netzspannung ok",
         info: "ja",
         submenu: [],
        },
        {
         heading: "Gestörte Detektoren",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Gestörte Lampen",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Persistenzspeicher ok",
         info: "ja",
         submenu: [],
        },
       ],
      },
     ],
    },
   ],
  },
  {
   heading: "Forum Gera: Stm.5 Forum Gera",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
    {
     heading: "Status",
     info: "",
     submenu: [
      {
       heading: "Status",
       info: "Schwer gestört",
       submenu: [],
      },
      {
       heading: "Kommunikation",
       info: "STm.5",
       submenu: [],
      },
      {
       heading: "Anlagenzustand",
       info: "unbekannt Aus - dunkel",
       submenu: [],
      },
      {
       heading: "Störungsstatus",
       info: "unbekannt abgeschaltet oder schwer gestört",
       submenu: [],
      },
      {
       heading: "Betriebsart",
       info: "unbekannt Lokale Zeitautomatik",
       submenu: [],
      },
      {
       heading: "letzte Statusänderung",
       info: "10.02.2023 11:17:34",
       submenu: [],
      },
      {
       heading: "Verkehrsabhängigkeit",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "ÖPNV",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Individualverkehr",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Status",
       info: "",
       submenu: [
        {
         heading: "Änderungszeitpunkt",
         info: "31.01.2023 10:37:27",
         submenu: [],
        },
        {
         heading: "Zeitquelle",
         info: "Zentrale",
         submenu: [],
        },
        {
         heading: "Not-Aus",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Tür auf",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Netzspannung ok",
         info: "ja",
         submenu: [],
        },
        {
         heading: "Gestörte Detektoren",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Gestörte Lampen",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Persistenzspeicher ok",
         info: "ja",
         submenu: [],
        },
       ],
      },
     ],
    },
   ],
  },
  {
   heading: "Forum Gera: Stm.5 Forum Gera",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
    {
     heading: "Status",
     info: "",
     submenu: [
      {
       heading: "Status",
       info: "Schwer gestört",
       submenu: [],
      },
      {
       heading: "Kommunikation",
       info: "STm.5",
       submenu: [],
      },
      {
       heading: "Anlagenzustand",
       info: "unbekannt Aus - dunkel",
       submenu: [],
      },
      {
       heading: "Störungsstatus",
       info: "unbekannt abgeschaltet oder schwer gestört",
       submenu: [],
      },
      {
       heading: "Betriebsart",
       info: "unbekannt Lokale Zeitautomatik",
       submenu: [],
      },
      {
       heading: "letzte Statusänderung",
       info: "10.02.2023 11:17:34",
       submenu: [],
      },
      {
       heading: "Verkehrsabhängigkeit",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "ÖPNV",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Individualverkehr",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Status",
       info: "",
       submenu: [
        {
         heading: "Änderungszeitpunkt",
         info: "31.01.2023 10:37:27",
         submenu: [],
        },
        {
         heading: "Zeitquelle",
         info: "Zentrale",
         submenu: [],
        },
        {
         heading: "Not-Aus",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Tür auf",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Netzspannung ok",
         info: "ja",
         submenu: [],
        },
        {
         heading: "Gestörte Detektoren",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Gestörte Lampen",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Persistenzspeicher ok",
         info: "ja",
         submenu: [],
        },
       ],
      },
     ],
    },
   ],
  },
  {
   heading: "Forum Gera: Stm.5 Forum Gera",
   info: "",
   submenu: [
    {
     heading: "Name",
     info: "STm.5",
     submenu: [],
    },
    {
     heading: "Ort",
     info: "Forum Gera",
     submenu: [],
    },
    {
     heading: "Anlagenart",
     info: "VS",
     submenu: [],
    },
    {
     heading: "Feldgerät-Nr",
     info: "41",
     submenu: [],
    },
    {
     heading: "Gruppen:",
     info: "Neuanlagen",
     submenu: [],
    },
    {
     heading: "Zeitautomatik",
     info: "Nill",
     submenu: [],
    },
    {
     heading: "ÖPNV-Typ",
     info: "AMLi Telegramm",
     submenu: [],
    },
    {
     heading: "Hersteller",
     info: "Stührenberg",
     submenu: [],
    },
    {
     heading: "Steuergerät",
     info: "STm.5 (Standleitung OCIT)",
     submenu: [],
    },
    {
     heading: "Bemerkungen",
     info: "Gerätestand 7.05",
     submenu: [],
    },
    {
     heading: "Status",
     info: "",
     submenu: [
      {
       heading: "Status",
       info: "Schwer gestört",
       submenu: [],
      },
      {
       heading: "Kommunikation",
       info: "STm.5",
       submenu: [],
      },
      {
       heading: "Anlagenzustand",
       info: "unbekannt Aus - dunkel",
       submenu: [],
      },
      {
       heading: "Störungsstatus",
       info: "unbekannt abgeschaltet oder schwer gestört",
       submenu: [],
      },
      {
       heading: "Betriebsart",
       info: "unbekannt Lokale Zeitautomatik",
       submenu: [],
      },
      {
       heading: "letzte Statusänderung",
       info: "10.02.2023 11:17:34",
       submenu: [],
      },
      {
       heading: "Verkehrsabhängigkeit",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "ÖPNV",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Individualverkehr",
       info: "unbekannt Aus",
       submenu: [],
      },
      {
       heading: "Status",
       info: "",
       submenu: [
        {
         heading: "Änderungszeitpunkt",
         info: "31.01.2023 10:37:27",
         submenu: [],
        },
        {
         heading: "Zeitquelle",
         info: "Zentrale",
         submenu: [],
        },
        {
         heading: "Not-Aus",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Tür auf",
         info: "nein",
         submenu: [],
        },
        {
         heading: "Netzspannung ok",
         info: "ja",
         submenu: [],
        },
        {
         heading: "Gestörte Detektoren",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Gestörte Lampen",
         info: "keine",
         submenu: [],
        },
        {
         heading: "Persistenzspeicher ok",
         info: "ja",
         submenu: [],
        },
       ],
      },
     ],
    },
   ],
  },
 ]

 const cardsPerPage = 3

 const handleNext = () => {
  if (startIndex + cardsPerPage < nestedArrayStructure.length) {
   setStartIndex(startIndex + cardsPerPage)
  }
 }

 const handlePrev = () => {
  if (startIndex - cardsPerPage >= 0) {
   setStartIndex(startIndex - cardsPerPage)
  }
 }
 // splitting array
 const Allcards = nestedArrayStructure.slice(startIndex, startIndex + cardsPerPage)

 // method for printing the devices status
 const handlePrint = useReactToPrint({
  content: () => componentRef.current,
 })

 return (
  <div>
   <div className="flex lg:flex-row flex-col justify-between lg:items-center w-[98%] px-2  py-4">
    <div>
     <h1 className="font-semibold text-2xl">{t("getCounts")}</h1>
     <p className="text-sm">
      Here you can transfer the metered values of the selected systems to the control center
     </p>
    </div>

    <div className="w-full lg:w-[18%] flex justify-end lg:justify-between lg:items-center">
     <button
      className="bg-dark-yellow px-6 py-1 font-semibold rounded hover:bg-[#FED749] hover:text-white"
      onClick={() => {
       handlePrint()
      }}
     >
      {t("print")}
     </button>
     <div className="flex lg:w-[35%] lg:justify-between">
      <button
       onClick={handlePrev}
       disabled={startIndex === 0}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex === 0 ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
      </button>
      <button
       disabled={startIndex + cardsPerPage >= nestedArrayStructure.length}
       onClick={handleNext}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex + cardsPerPage >= nestedArrayStructure.length ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-90" src={openIcon} alt="next" />
      </button>
     </div>
    </div>
   </div>

   <div
    ref={componentRef}
    className="flex lg:flex-row flex-col gap-3 overflow-x-scroll  hide-scroll-icon"
   >
    {Allcards.map((item, index) => (
     <div key={index} className="min-w-[45%] ">
      {/* =========== StatusItem component for removing duplicates ====== */}
      <CountsItem item={item} index={index} />
     </div>
    ))}
   </div>
  </div>
 )
}
